/**
 * Checks whether a point is isolated
 *
 * @param points - array of data
 * @param index - current index of the point
 * @param isDefined - accessor to check if a given point is defined
 * @returns boolean
 */
export function isIsolatedPoint<Datum>(
  points: Datum[],
  index: number,
  isDefined: (point: Datum) => boolean,
): boolean {
  if (points.length < 2) {
    return false;
  }

  const point = points[index];
  const prevPoint = points[index - 1];
  const nextPoint = points[index + 1];

  const prevIsGap = !prevPoint || !isDefined(prevPoint);
  const nextIsGap = !nextPoint || !isDefined(nextPoint);

  return isDefined(point) && prevIsGap && nextIsGap;
}
